import { BroadcastModel } from './broadcast.model';

export class BroadcastFactory {
  public static new(data?: Partial<BroadcastModel>): BroadcastModel {
    return new BroadcastModel(data);
  }

  public static getModel(): any {
    return BroadcastModel;
  }

  public static getPath(): string {
    return 'broadcasts';
  }
}
